







































































































	import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
	import { AppSettings, HellospokeUser,store, StoreState } from '../../../store';
	import util from '../../../lib/util';
    import { truncate } from 'fs';
	import { mapState } from 'vuex';
	import QuickCall from '../../QuickCall.vue';

	
@Component({
  components: {
			QuickCall
        },
  computed: {
    ...mapState({
        
        'show_quick_call_modal': (state: StoreState) => state.dashboard.show_quick_call_modal,
        'number_to_call': (state: StoreState) => state.dashboard.number_to_call,
    })
  }
})
	export default class AdminContentRow extends Vue {
		 

		data() {
			return {
				add_manager_1: false,
				add_manager_2: false,
				 clr_index:0,
				 clr_limit:2,
				expand_id:'',
			}
		}

		@Prop()
		public users!: HellospokeUser[];

		@Prop()
		public user!: HellospokeUser;

        @Watch('user')
        onChange() {
            this.$data.add_manager_1 = false;
            this.$data.add_manager_2 = false;
		}

		Onchange_upadetuser(id){
			//alert(this.$props.user.assigned_managers[0])
			this.$props.users.forEach(element => {
				if(element.presence_id==id){
                  element.update_status= true;
				}
              });
		}

		change_recording(id){   
			var callrecord_on=0;
			var callrecord_off=0;
			this.$props.users.forEach(element => {
				if(element.presence_id==id){
                  element.update_status=  true;
				}
				if(element.callrecord_internal=="true"&&element.callrecord_external=="true"){
					callrecord_on=1+ callrecord_on;
				}
				if(element.callrecord_internal!="true"&&element.callrecord_external!="true"){
					callrecord_off=1+ callrecord_off;
				}
			    });
			    if(this.$props.users.length==callrecord_on){
					this.$emit('radiochange',true)
				}
				if(this.$props.users.length==callrecord_off){
					this.$emit('radiochange',false)
				}
				if(this.$props.users.length!=callrecord_off && this.$props.users.length!=callrecord_on){
					this.$emit('radiochange','')
				}
		}
		show_less(){
			this.$data. clr_index=0;
			this.$data. clr_limit=2;
			this.$data.expand_id='';
		}
        showall(id){
			this.$data.expand_id=id;
			this.$data. clr_index=0;
			this.$data. clr_limit=2;
			 this.$props.users.forEach(element => { 
				 if(element.presence_id==id){
                   this.$data. clr_limit=element.text_permissions.length;
				 }
			 });

			 this.$props.users.forEach(function(key, value){
				console.log(key, value)
			 })
			
		}
		 quickCall(number) {
            this.$store.commit('QUICK_CALL', number);
		}
		
		//Gets all valid managers for a user
		addManagerOptions(manager_no: any) {
			var _managers= this.$props.users.filter((element: any) => {
				//Don't add self
				if(element._id === this.$props.user._id) {
					return false;
				}
			    this.$props.user.assigned_managers
				//If you already have a manager, don't list them again
				var found = false;
				this.$props.user.assigned_managers.forEach((manager,index) => {
					if (index!=manager_no && manager._id===element._id)
						{
							found=true;
						}
				});
				if (found) return false;
				//Make sure managers have higer priv_level than user
				if(this.$props.user.priv_level === "voitress-admin" || this.$props.user.priv_level === "admin") {
					return false;
				}
				else if(this.$props.user.priv_level === "manager" &&  element.priv_level === "user") {
					return false;
				}
				else if(element.priv_level === "user") {
					return false;
				}
				return true;
			});
			return _managers;
		}

		showManagerColumn() {
			if ( this.$props.user.priv_level ==="user"
					&&this.$props.user.assigned_users
					 && this.$props.user.assigned_users.length>0)
					 {
						var assigned_users=this.$props.user.assigned_users;
						assigned_users.forEach(assigneduser => {
							this.$props.users.forEach(user => {
								if (assigneduser===user._id)
									var i=0;
									user.assigned_managers.forEach(manager => {
										if (manager._id===this.$props.user._id)
										{
											manager="remove-manager";
											user.update_status=true;
											user.assigned_managers[i]=manager;
										}
										i++;
									});
							});
						});
					 }

			return !(this.$props.user.priv_level === "admin" ||
			this.$props.user.priv_level === "voitress-admin")
		}

		formatPhoneNumber(phoneNumber: string) {
			return util.formatPhoneNumber(phoneNumber);
		}

		// addManager1() {
		// 	if(this.$props.user.assigned_managers.length < 1) {
		// 		this.$props.user.assigned_managers.push("none");
		// 	}
		// 	else if(!this.$props.user.assigned_managers[0]) {
		// 		this.$props.user.assigned_managers[0] = "none"
		// 	}
		// 	this.$data.add_manager_1 = true;
		// }

		addManager1(index_) {
			this.$data.limitmanager=10 - this.$props.user.assigned_managers.length;
			this.$data.limitmanager=this.$data.limitmanager - 1;
			this.$props.user.assigned_managers.push('none');
			this.$data.add_manager_1 = true;
			
		}

		addManager2(id) {
			if(this.$props.user.assigned_managers.length < 1) {
				this.$props.user.assigned_managers.push(null, null);
				this.$props.user.assigned_managers[1] = "none"
			}
			else if(this.$props.user.assigned_managers.length < 2) {
				this.$props.user.assigned_managers.push("none");
			}
			this.$data.add_manager_2 = true;
            this.Onchange_upadetuser(id);
 
		}
	}
